import { FormlyFieldConfig } from 'ng-formly';
export const entityFields = [
    {
        key: 'name',
        type: 'input-field',
        className: 'col-md-4',
        templateOptions: {
            type: 'text',
            placeholder: 'Unique name for the entity',
            required: true,
            label: 'Entity Name'
        }
    },
    {
        key: 'label',
        type: 'input-field',
        className: 'col-md-4',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: true,
            label: 'Label'
        }
    },
    {
        key: 'plural_label',
        type: 'input-field',
        className: 'col-md-4',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: true,
            label: 'Plural Label'
        }
    },
    {
        key: 'description',
        type: 'textarea-field',
        className: 'col-md-12',
        templateOptions: {
            placeholder: '',
            required: true,
            label: 'Description'
        }
    },
    {
        className: 'col-md-12',
        template: '<hr>',
    },
    {
        key: 'deployment_status',
        type: 'select-component',
        className: 'col-md-3',
        defaultValue: 'dev',
        templateOptions: {
            options: [
                {
                    label: 'Development',
                    value: 'dev'
                },
                {
                    label: 'Sandbox',
                    value: 'sandbox'
                },
                {
                    label: 'Trial',
                    value: 'trial'
                },
                {
                    label: 'Production',
                    value: 'prod'
                }
            ],
            label: 'Status',
            required: true,
            placeholder: 'Select Status'
        }
    },
    {
        key: 'defaultsearchlayout',
        type: 'select-component',
        hideExpression: '!model.id',
        className: 'col-md-3',
        templateOptions: {
            type: 'entitysearchlayout',
            label: 'Default Search Layout',
            required: false,
            placeholder: '',
            description: 'Default Search Layout for this entity'
        }
    },
    {
        key: 'defaultpagelayout',
        type: 'select-component',
        hideExpression: '!model.id',
        className: 'col-md-3',
        templateOptions: {
            type: 'entitypagelayout',
            label: 'Default Page Layout',
            required: false,
            placeholder: '',
            description: 'Default Page Layout for this entity'
        }
    },
    {
        key: 'peekpagelayout',
        type: 'select-component',
        hideExpression: '!model.id',
        className: 'col-md-3',
        templateOptions: {
            type: 'entitypagelayout',
            label: 'Peek Page Layout',
            required: false,
            placeholder: '',
            description: 'Peek Page Layout for this entity'
        }
    },
    {
        className: 'col-md-12',
        hideExpression: '!model.id',
        template: '<hr>',
    },
    {
        key: 'record_name',
        type: 'input-field',
        className: 'col-md-3',
        defaultValue: 'name',
        templateOptions: {
            type: 'text',
            description: 'Valid Field to identify the record',
            required: true,
            label: 'Record Name Field'
        }
    },
    {
        key: 'record_name_datatype',
        type: 'input-field',
        className: 'col-md-3',
        hideExpression: '!model.id',
        defaultValue: 'text',
        templateOptions: {
            type: 'text',
            placeholder: '',
            description: 'Datatype of Record Name Field',
            required: false,
            label: 'Record Name Datatype'
        }
    },
    {
        key: 'record_name_format',
        type: 'input-field',
        className: 'col-md-3',
        hideExpression: '!model.id',
        defaultValue: 'text',
        templateOptions: {
            type: 'text',
            placeholder: '',
            description: 'Format of Record Name Field',
            required: false,
            label: 'Record Name Format'
        }
    },
    {
        key: 'collection',
        type: 'input-field',
        className: 'col-md-4',
        defaultValue: 'entityrecord',
        templateOptions: {
            placeholder: '',
            description: 'Database collection name in which the entity related records are stored',
            required: false,
            label: 'Collection Name'
        }
    },
    {
        className: 'col-md-12',
        template: '<hr>',
    },
    {
        key: 'parentId',
        type: 'select-component',
        className: 'col-md-3',
        templateOptions: {
            label: 'Parent Entity',
            type: 'entity',
            multiple: false,
            required: false,
            placeholder: '',
            description: 'Select the parent entity'
        }
    },
    {
        key: 'parentId_sortorder',
        type: 'input-field',
        className: 'col-md-3',
        hideExpression: '!model.parentId',
        templateOptions: {
            type: 'number',
            placeholder: '',
            required: false,
            label: 'Child Entity Sort Order'
        }
    },
    {
        key: 'parentId_embeddedchild',
        type: 'checkbox',
        className: 'col-md-3',
        hideExpression: '!model.parentId',
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Embedded Child ?'
        }
    },
    {
        key: 'parentId_onetoone',
        type: 'checkbox',
        className: 'col-md-3',
        hideExpression: '!model.parentId',
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'One to One Parent to Child Relation'
        }
    },
    {
        className: 'col-md-12',
        template: '<hr>',
    },
    {
        key: 'hide_detail_page',
        type: 'checkbox',
        className: 'col-md-3',
        defaultValue: true,
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Hide Detail Page View'
        }
    },
    {
        key: 'open_detail_page_on_create',
        type: 'checkbox',
        className: 'col-md-3',
        hideExpression: 'model.hide_detail_page',
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Open Detail Page on Create'
        }
    },
    {
        key: 'disable_peek_mode',
        type: 'checkbox',
        className: 'col-md-3',
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Disable Peek Mode'
        }
    },
    {
        key: 'hide_delete',
        type: 'checkbox',
        className: 'col-md-3',
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Prevent Deletion'
        }
    },
    {
        key: 'prevent_edit',
        type: 'checkbox',
        className: 'col-md-3',
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Prevent Edit'
        }
    },
    {
        key: 'enable_custom_action',
        type: 'checkbox',
        className: 'col-md-3',
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Enable Custom Action'
        }
    },
    {
        key: 'enable_currency_consolidation',
        type: 'checkbox',
        className: 'col-md-3',
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Enable Currency Consolidation'
        }
    },
    {
        className: 'col-md-12',
        template: '<hr>',
    },
    {
        key: 'create_status_field',
        type: 'checkbox',
        className: 'col-md-3',
        hideExpression: 'model.id',
        defaultValue: false,
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Create Status Field'
        }
    },
    {
        key: 'create_name_field',
        type: 'checkbox',
        className: 'col-md-3',
        hideExpression: 'model.id',
        defaultValue: false,
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Create Name Field'
        }
    },
    {
        key: 'create_parentId_field',
        type: 'checkbox',
        className: 'col-md-3',
        hideExpression: 'model.id',
        defaultValue: false,
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Create ParentId Field'
        }
    },
    {
        key: 'create_uniqueId_field',
        type: 'checkbox',
        className: 'col-md-3',
        hideExpression: 'model.id',
        defaultValue: false,
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Create UniqueId Field'
        }
    },
    {
        key: 'maintain_sortorder_field',
        type: 'checkbox',
        className: 'col-md-3',
        defaultValue: false,
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Maintain Sortorder'
        }
    },
    {
        key: 'showinnerform',
        type: 'checkbox',
        className: 'col-md-3',
        defaultValue: false,
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Show Inner Form'
        }
    },
    {
        key: 'create_timeseries',
        type: 'checkbox',
        className: 'col-md-3',
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Create Time Series'
        }
    },
    {
        className: 'col-md-12',
        template: '<hr>',
    },
    {
        key: 'vowel_start',
        type: 'checkbox',
        className: 'col-md-3',
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Starts with a vowel'
        }
    },
    {
        key: 'allow_reports',
        type: 'checkbox',
        className: 'col-md-3',
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Allow Reports'
        }
    },
    {
        key: 'page_add_notes',
        type: 'checkbox',
        className: 'col-md-3',
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Allow add notes to Entity'
        }
    },
    {
        key: 'track_field_history',
        type: 'checkbox',
        className: 'col-md-3',
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Track field history'
        }
    },
    {
        className: 'col-md-12',
        template: '<hr>',
    },

    {
        key: 'formtemplate',
        type: 'textarea-field',
        className: 'col-md-12',
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Form Template (Please Minify the JSON before Pasting here)',
            rows: 10
        }
    },
    {
        className: 'col-md-12',
        template: '<hr>',
    },

    {
        className: 'col-md-12',
        type: 'repeatedsection',
        key: 'rolerestrictions',
        fieldArray: {
            className: 'row',
            templateOptions: {
                btnText: 'Add',
                label: 'Entity Record restrictions for Role'
            },
            fieldGroup: [
                {
                    className: 'col-md-4',
                    key: 'role',
                    type: 'select-component',
                    templateOptions: {
                        type: 'profile',
                        placeholder: '',
                        required: false,
                        label: 'Role'
                    }
                },
                {
                    className: 'col-md-12',
                    template: '<hr>',
                },

                {
                    className: 'col-md-2',
                    template: '<h3 style="margin-top:20px">Create</h3>',
                },
                {
                    className: 'col-md-5',
                    key: 'createrestrictiontype',
                    type: 'select-component',
                    templateOptions: {
                        options: [{
                            label: 'All Records',
                            value: 'allrecords'
                        }, {
                            label: 'No access',
                            value: 'noaccess'
                        }, {
                            label: 'Based on user id',
                            value: 'userid'
                        }, {
                            label: 'Based on Role-Entity Association',
                            value: 'entityassociation'
                        }],
                        placeholder: '',
                        label: 'Restriction Type'
                    }
                },
                {
                    className: 'col-md-5',
                    key: 'createfieldmapping',
                    type: 'select-component',
                    templateOptions: {
                        type: 'entityfield',
                        placeholder: '',
                        required: false,
                        label: 'Map to Field'
                    },
                    expressionProperties: {
                        'templateOptions.disabled': 'model.createrestrictiontype !== "entityassociation"'
                    }
                },
                {
                    className: 'col-md-2',
                    template: '<h3 style="margin-top:10px">Read</h3>',
                },
                {
                    className: 'col-md-5',
                    key: 'readrestrictiontype',
                    type: 'select-component',
                    templateOptions: {
                        options: [{
                            label: 'No access',
                            value: 'noaccess'
                        }, {
                            label: 'Based on user id',
                            value: 'userid'
                        }, {
                            label: 'Based on Role-Entity Association',
                            value: 'entityassociation'
                        }],
                        placeholder: '',
                        label: 'Restriction Type'
                    }
                },
                {
                    className: 'col-md-5',
                    key: 'readfieldmapping',
                    type: 'select-component',
                    templateOptions: {
                        type: 'entityfield',
                        placeholder: '',
                        required: false,
                        label: 'Map to Field'
                    },
                    expressionProperties: {
                        'templateOptions.disabled': 'model.readrestrictiontype !== "entityassociation"'
                    }
                },
                {
                    className: 'col-md-2',
                    template: '<h3 style="margin-top:10px">Update</h3>',
                },
                {
                    className: 'col-md-5',
                    key: 'updaterestrictiontype',
                    type: 'select-component',
                    templateOptions: {
                        options: [{
                            label: 'No access',
                            value: 'noaccess'
                        }, {
                            label: 'Based on user id',
                            value: 'userid'
                        }, {
                            label: 'Based on Role-Entity Association',
                            value: 'entityassociation'
                        }],
                        placeholder: '',
                        label: 'Restriction Type'
                    }
                },
                {
                    className: 'col-md-5',
                    key: 'updatefieldmapping',
                    type: 'select-component',
                    templateOptions: {
                        type: 'entityfield',
                        placeholder: '',
                        required: false,
                        label: 'Map to Field'
                    },
                    expressionProperties: {
                        'templateOptions.disabled': 'model.updaterestrictiontype !== "entityassociation"'
                    }
                },
                {
                    className: 'col-md-2',
                    template: '<h3 style="margin-top:20px">Delete</h3>',
                },
                {
                    className: 'col-md-5',
                    key: 'deleterestrictiontype',
                    type: 'select-component',
                    templateOptions: {
                        options: [{
                            label: 'No access',
                            value: 'noaccess'
                        }, {
                            label: 'Based on user id',
                            value: 'userid'
                        }, {
                            label: 'Based on Role-Entity Association',
                            value: 'entityassociation'
                        }],
                        placeholder: '',
                        label: 'Restriction Type'
                    }
                },
                {
                    className: 'col-md-5',
                    key: 'deletefieldmapping',
                    type: 'select-component',
                    templateOptions: {
                        type: 'entityfield',
                        placeholder: '',
                        required: false,
                        label: 'Map to Field'
                    },
                    expressionProperties: {
                        'templateOptions.disabled': 'model.deleterestrictiontype !== "entityassociation"'
                    }
                }
            ]
        }
    },
    {
        key: 'related_activities',
        type: 'multicheckbox',
        className: 'col-md-6',
        templateOptions: {
            placeholder: '',
            options: [{
                key: 'task',
                value: 'Task',
            }, {
                key: 'call',
                value: 'Call',
            }, {
                key: 'visit',
                value: 'Visit',
            }, {
                key: 'event',
                value: 'Event',
            }],
            required: false,
            label: 'Related Activities'
        }
    },
    {
        key: 'eventtriggers',
        type: 'multicheckbox',
        className: 'col-md-6',
        templateOptions: {
            placeholder: '',
            options: [{
                key: 'event',
                value: 'Event',
            }],
            required: false,
            label: 'Related Events'
        }
    }
]


// WEBPACK FOOTER //
// ./src/app/shared/formfields/entity.ts